import BenchmarkDashboardContainer from './containers/BenchmarkDashboardContainer';

export default BenchmarkDashboardContainer;
